module.exports = __webpack_public_path__ + "static/map_icon-7cc3c102bab968bf6a354612de23845b.png";